/*********************
AND Rule
*********************/
import Rule from '../Rule';
import { ruleInputTypes, ruleTypes } from '../../../constants';
import getRule from '../ruleFactory';
import { LOG_DECISION_CONTEXT } from '../../../config';

// Note: "logic" param is a rules object param for combo rules
export default class AndRule extends Rule {
  constructor(rules, interventionType) {
    super([]);
    this.ruleType = ruleTypes.AND;
    this.rules = [];
    this.requiredFields = [];

    Object.entries(rules).forEach(([ruleType, logic]) => {
      // combo rules can occur multiple times, and therefore
      // need to be striped of an identifying charecter
      // (e.g. or1, or2)
      if(ruleType.includes(ruleTypes.OR) && ruleType.length < 4) {
        ruleType = ruleTypes.OR;
      } else if(ruleType.includes(ruleTypes.AND)  && ruleType.length < 5) {
        ruleType = ruleTypes.AND;
      }

      this.addRule(getRule(ruleType, logic, interventionType));
    });
  }

  ///// Add Rule
  addRule(rule) {
    // Add the rule's inputTypes to the Intervention's requiredFields
    rule.getInputTypes().forEach(inputType => {
      if(!this.requiredFields.includes(inputType)) {
        this.requiredFields.push(inputType);
      };
    });

    // Add the rule to "rules"
    this.rules.push(rule);
  }

  getInputTypes() {
    return this.requiredFields;
  }

  // Takes state, runs each rule's logic, and returns a bool based on
  // whether every rule is true
  run(state) {
    let ruleLog = [];
    // Recursively run this rule's rules
    let allRulesAreTrue = true;
    let rulesDecisionContext = [];
    this.rules.some(rule => {
      let {stateMeetsRuleCondition, decisionContext, log} = rule.run(state);
      LOG_DECISION_CONTEXT && rulesDecisionContext.push(decisionContext);
      LOG_DECISION_CONTEXT && ruleLog.push(log);
      if(!stateMeetsRuleCondition) {
        allRulesAreTrue = false; // take the AND of the rules
        return true; // break the loop
      }
      return false; // AND rule still valid so far
    });

    //// LOGGING LOGIC BLOCK
    let stateMeetsRuleCondition = allRulesAreTrue;
    let decisionContext;
    let log;
    if(LOG_DECISION_CONTEXT) {
      decisionContext = {[(this.ruleType + '_' + allRulesAreTrue)]: rulesDecisionContext};
      log = {and: ruleLog};
    }//// END OF LOGGING LOGIC BLOCK
    return {stateMeetsRuleCondition, decisionContext, log};
  }
}